export class StorageDataType {
  date?: Date;
  name: string;
  owner?: string;
  path: string;
  size?: string;
  type: string;
  value?: any;
  isUploadCompleted?: boolean

  constructor(name: string, type: string, path: string, value?:any, owner?: string, date?: Date, size?: string, isUploadCompleted: boolean = false) {
    this.name = name;
    this.type = type;
    this.path = path;
    this.value = value;
    this.owner = owner;
    this.date = date;
    this.size = size;
    this.isUploadCompleted = isUploadCompleted;
  }
}

export class StorageDataLevel {
  ui_name: string;
  name: string;
  path: string;
  className: string;

  constructor(ui_name: string, name: string, path: string, className: string) {
    this.ui_name = ui_name;
    this.name = name;
    this.path = path;
    this.className = className;
  }
}

export class LogData{
  type: string;
  name?: string;
  percent?: string;
  id?: number;

  constructor(type: string, name?: string, percent?: string, id?:number){
    this.type = type;
    this.name = name;
    this.percent = percent;
    this.id = id
  }
}

export class DeleteData
{
  type: string;
  name: string;
  store: string;

  constructor(type: string, name: string, store: string){
    this.type = type;
    this.name = name;
    this.store = store;
  }
}

export class PipeBreadcrumb{
  constructor(
    public itemName: string,
    public itemPath: string
  ){}
}
